<template>
  <div class="hexCalc">
    <h2>{{ superPassword }}</h2>
  </div>
</template>

<script>
import request from '../utils/request.js'
export default {
  name: 'HexCalc',
  data() {
    return {
      superPassword: ''
    }
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      request({
        url: '/api/getSuperPassword',
        method: 'post',
        data: ''
      }).then(Response => {
        console.log(Response.data)
        this.superPassword = Response.data.data
      })
    }
  }
}
</script>
